import {DashboardState} from './dashboardModel';

/** Minimal scaffold; real data is overlaid in useRealDashboardData. */
export function createInitialDashboardState(now: number = Date.now()): DashboardState {
  return {
    now,
    stats: [
      {
        id: 'stock',
        label: 'DBX',
        value: '—',
        caption: 'Dropbox, Inc.',
        kind: 'stock',
      },
    ],
    agenda: [],
    timezoneGroups: [],
    viewerZone: null,
    jiraTickets: [],
    newArrivals: [],
    news: [],
    featuredPerson: null,
    latestGratitude: null,
  };
}
